import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dashboard-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-header.component.html',
  styleUrl: './dashboard-header.component.css'
})
export class DashboardHeaderComponent {
  @Input({ required: true }) activePeriodLabel!: string;
  @Input() operationsTotal = 0;
  @Input() busy = false;
  @Input() isWeekClosed = false;
  @Input() isToday = false;
  @Input() isWeek = true;
  @Input() isMonth = false;

  @Output() quickRange = new EventEmitter<'today' | 'week' | 'month'>();
  @Output() print = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();
  @Output() settings = new EventEmitter<void>();
}
